import { CART_QUERY, storefrontApiRequest } from '@/lib/shopify';

/**
 * Fetch the current cart without mutating discounts or cart lines.
 *
 * Promotion codes are entered by the customer in Shopify checkout. A checkout
 * attempt must never fail because a promotion is inactive, invalid, expired,
 * already applied, or unavailable for one of the cart lines.
 */
export async function prepareShopifyCheckout(
  cartId: string
): Promise<{ checkoutUrl: string; totalQuantity: number } | null> {
  const data = await storefrontApiRequest(CART_QUERY, { id: cartId });
  const cart = data?.data?.cart;

  if (!cart?.checkoutUrl || !cart?.totalQuantity) return null;

  return {
    checkoutUrl: cart.checkoutUrl,
    totalQuantity: cart.totalQuantity,
  };
}
